module.exports = __webpack_public_path__ + "img/return-返回左.a62f395c.png";